const dev = false;
const localHost = 'http://wst.qihe.local';
const proHost = 'http://wst-api.zj-qq.cn';
const devHost = dev ? localHost : proHost;
const host = process.env.NODE_ENV === 'production' ? proHost : devHost

export default {
  host,
  token: null
}
